import { createTheme } from '@mui/material/styles';

const theme = createTheme({
  palette: {
    primary: {
      main: '#007C21', // ta couleur primaire
      mainLight: '#4CAF50', // exemple de couleur primaire claire
    },
    secondary: {
       // exemple de secondaire
      main: '#767676',
      main2: 'B39C81'
    },
    background: {
      paper: '#f5f5f5', // couleur du 'background.paper'
      default: '#ffffff',
    },
  },
  typography: {
    fontFamily: 'Hurme Geometric, Arial, sans-serif',
  },
  shape: {
    borderRadius: 8, // rayon par défaut
  }
});

export default theme;